module.exports = __webpack_public_path__ + "static/media/01.0bbff9da.mp3";